import React, { PropsWithChildren, useCallback, useState } from 'react';
import { Portal } from '@chakra-ui/react';
import { AlertPopup, AlertPopupProps } from '@/modules/utils/modals/alert/AlertPopup';

export type ShowAlertProps = Omit<AlertPopupProps, 'closePopup'>;

export function useAlert() {
  const context = React.useContext(AlertContext);
  if (context === undefined) {
    throw new Error('useAlert must be used within AlertContext');
  }
  return context;
}

export const AlertContext = React.createContext<{
  showAlert: (props: ShowAlertProps) => void;
}>({
  showAlert: () => {
    throw new Error('showAlert - AlertContext not initialized');
  },
});

export const AlertProvider = ({ children }: PropsWithChildren) => {
  const [dialog, setDialog] = useState<React.ReactNode>();
  const showAlert = useCallback(
    (props: ShowAlertProps) => {
      setDialog(<AlertPopup {...props} closePopup={() => setDialog(undefined)} />);
    },
    [setDialog],
  );
  return (
    <AlertContext.Provider value={{ showAlert }}>
      <Portal>{dialog}</Portal>
      {children}
    </AlertContext.Provider>
  );
};
